// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-sidebar .radio {
  display: flex;
  flex-direction: column;
}
.download-sidebar .radio .radio__title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 1.5rem;
  margin-bottom: 0.9rem;
}
.download-sidebar .radio .radio__label {
  font-size: 1.4rem;
  margin-bottom: 0.2rem;
}
.download-sidebar .radio .radio__item-title {
  display: flex;
  align-items: center;
}
.download-sidebar .radio .radio__item-description {
  font-size: 1.2rem;
  color: #676767;
  padding-top: 0;
  padding-left: 2.4rem;
  margin-bottom: 0.8rem;
}
.download-sidebar .download-button {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 9.2rem;
}
.download-sidebar .download-button button {
  width: 20rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Sidebars/DownloadSidebar/DownloadSidebarForm/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;AAAN;AAGI;EACE,iBAAA;EACA,qBAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;AAFN;AAKI;EACE,iBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;AAHN;AAOE;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;AALJ;AAOI;EACE,YAAA;AALN","sourcesContent":[".download-sidebar {\n  .radio {\n    display: flex;\n    flex-direction: column;\n\n    .radio__title {\n      font-size: 1.2rem;\n      font-weight: bold;\n      margin-top: 1.5rem;\n      margin-bottom: 0.9rem;\n    }\n\n    .radio__label {\n      font-size: 1.4rem;\n      margin-bottom: 0.2rem;\n    }\n\n    .radio__item-title {\n      display: flex;\n      align-items: center;\n    }\n\n    .radio__item-description {\n      font-size: 1.2rem;\n      color: #676767;\n      padding-top: 0;\n      padding-left: 2.4rem;\n      margin-bottom: 0.8rem;\n    }\n  }\n\n  .download-button {\n    display: flex;\n    flex-direction: row-reverse;\n    margin-top: 9.2rem;\n\n    button {\n      width: 20rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
